import React, { useEffect, useState } from "react";
import { api } from "../utils/api";
import { STORAGE_AGE_MINUTES } from "../constants";
import DataStore from "../store/DataStore";
import { DataState } from "../types/enums";
import classNames from "../utils/classnames";
const getClasses = (classNamePrefix, name, fetchingState, initialClass) => {
    const classes = [
        classNamePrefix + "-data",
        `${classNamePrefix}-${name}`,
    ];
    if (initialClass) {
        classes.push(initialClass);
    }
    switch (fetchingState) {
        case DataState.Fetching:
            classes.push(classNamePrefix + "-loading");
            break;
        case DataState.Fetched:
            classes.push(classNamePrefix + "-loaded");
            break;
        case DataState.Error:
            classes.push(classNamePrefix + "-error");
            break;
    }
    return classes;
};
const getContent = (fetching, value, loading, error) => {
    if (value !== null) {
        return value;
    }
    else if (fetching === DataState.Fetching && loading) {
        return loading;
    }
    else if (fetching === DataState.Error && error) {
        return error;
    }
    return "";
};
const defaultFormatter = (value) => {
    if (typeof value === "number") {
        return value.toLocaleString();
    }
    return value;
};
const getClassName = (name) => (name.startsWith("GitHub") ? name.slice(6) : name).toLowerCase();
const createDataComponent = (version, name, classNamePrefix, createDataUrl, createIdentifier, getValue, mapResponse) => {
    const store = new DataStore(name, STORAGE_AGE_MINUTES, version);
    const Component = (props) => {
        const identifier = createIdentifier(props);
        const [entry, setEntry] = useState(store.get(identifier));
        useEffect(() => store.subscribe(identifier, (entry) => setEntry(Object.assign({}, entry))), [identifier]);
        useEffect(() => {
            if (!store.isWaiting(identifier)) {
                return;
            }
            api(createDataUrl(props))
                .then((data) => mapResponse(data))
                .then((data) => store.setData(identifier, data))
                .catch((reason) => {
                console.error(`Could not load data for component ${name} (${identifier}):`, reason.message);
                store.setState(identifier, DataState.Error);
            });
        }, [identifier, props]);
        useEffect(() => {
            var _a, _b;
            if (entry.state === DataState.Fetched) {
                (_a = props.onDataLoad) === null || _a === void 0 ? void 0 : _a.call(this);
            }
            else if (entry.state === DataState.Error) {
                (_b = props.onDataError) === null || _b === void 0 ? void 0 : _b.call(this);
            }
        }, [entry.state, props.onDataError, props.onDataLoad]);
        let content = null;
        if (entry.data && props.content) {
            content = props.content(entry.data);
        }
        else {
            const value = entry.data ? getValue(props, entry.data) : null;
            content = value !== null ? defaultFormatter(value) : null;
        }
        return (React.createElement("div", { id: props.id, className: classNames(getClasses(classNamePrefix, getClassName(name), entry.state, props.className)) }, getContent(entry.state, content, props.loading, props.error)));
    };
    Component.displayName = name;
    return Component;
};
export default createDataComponent;
//# sourceMappingURL=createDataComponent.js.map